import React from 'react';
import { connect } from 'react-redux';
import Promise from 'bluebird';
import _ from 'lodash';
import FormField from 'scy/FormField';
import { LoadingButton, TextButton } from 'scy/buttons';
import { Body } from 'scy/text';
import { DangerWarning } from 'scy/Warning';
import margin from 'scy/margin.mod.scss';
import { textLeft, textRight, width100 } from 'scy/utils.mod.scss';
import { sendPIN, verifyPIN } from 'shared/models/api';
import { updateUser } from 'shared/components/login/actions';

class MobileVerification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: '',
      requestingPIN: false,
      loading: false,
      errors: {},
      error: null
    };
  }

  componentDidMount() {
    return this.requestPIN();
  }

  requestPIN() {
    this.timestamp = Date.now();
    this.setState({ requestingPIN: true, error: null });
    return sendPIN(this.timestamp)
      .then(() => this.setState({ requestingPIN: false }))
      .catch(res => {
        const message =
          (res.body && res.body.message) || 'Something went wrong';
        this.setState({ requestingPIN: false, error: message });
      });
  }

  validatePIN(pin) {
    const isFourDigits = /^\d{4}$/.test(pin);
    if (!isFourDigits) {
      return 'Enter 4-digit PIN';
    }
  }

  validate() {
    let errors = {};
    errors.pin = this.validatePIN(this.state.pin) || null;
    this.setState({ errors });
    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true, error: null });
    return this.validate()
      .then(() => verifyPIN({ pin: this.state.pin, timestamp: this.timestamp }))
      .then(() => this.setState({ loading: false, error: null }))
      .then(() => this.props.updateUser({ mobileVerified: true }))
      .then(() => this.props.onSuccess && this.props.onSuccess())
      .catch(res => {
        const message =
          (res.body && res.body.message) || 'Something went wrong';
        this.setState({ loading: false, error: message });
      });
  }

  render() {
    return (
      <div>
        <Body className={margin.bottom_sm}>
          A 4-digit PIN was sent to your mobile number.
        </Body>

        <form onSubmit={e => this.handleSubmit(e)}>
          <div className="row">
            <div className={`col-xs-12 ${textLeft}`}>
              <FormField
                id="user-mobile-pin"
                inputType="tel"
                maxLength={4}
                labelText="Enter 4-digit PIN"
                initialValue={this.state.pin}
                updatedValue={this.state.pin}
                onChange={pin => this.setState({ pin })}
                validate={pin => this.validatePIN(pin)}
                error={this.state.errors.pin}
              />
            </div>
          </div>

          {this.state.error && (
            <div className="row">
              <div className="col-xs-12">
                <DangerWarning>{this.state.error}</DangerWarning>
              </div>
            </div>
          )}

          <div className="row center-xs end-sm">
            <div className="col-xs-12 col-sm-6 col-md-5">
              <div className={`${margin.bottom_sm} ${textRight}`}>
                <LoadingButton
                  className={width100}
                  type="submit"
                  disabled={this.state.loading || this.state.requestingPIN}
                  loading={this.state.loading}
                >
                  Continue
                </LoadingButton>
              </div>
              <div className={margin.bottom_sm}>
                <small>
                  I didn{"'"}t receive a PIN.{' '}
                  <TextButton
                    type="button"
                    disabled={this.state.requestingPIN}
                    onClick={() => this.requestPIN()}
                  >
                    Please resend it.
                  </TextButton>
                </small>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const ConnectedMobileVerification = connect(
  null,
  { updateUser }
)(MobileVerification);

export default ConnectedMobileVerification;
